export function useCondensedPlansPage(): boolean {
  return true;
}
